<script>
import Style from "@/views/layouts/style";
import appConfig from "@/../app.config";
import Swal from "sweetalert2";
import moment from "moment";
import { dateFormat } from "@/utils/helpers/format";
import { sendNotification } from "@/utils/helpers/notification";
import { v4 as uuidv4 } from 'uuid';
import Consolidado from "../../pages/forms/evaluacion-indicadores-consolidado.vue"
import Estructura from "../../pages/forms/evaluacion-indicadores-estructura.vue"
import Proceso from "../../pages/forms/evaluacion-indicadores-proceso.vue"
import Resultado from "../../pages/forms/evaluacion-indicadores-resultado.vue"
import indicadoresAPI from "../../../services/standards/indicadores/indicadoresAPI";
import evaluacionIndicadoresAPI from "../../../services/standards/evaluacionIndicadores/evaluacionIndicadoresAPI";
import IndicadoresEstructuraPagination from "../../../components/standard/indicadores/IndicadoresEstructuraPagination.vue";

export default {
  page: {
    title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Style,
    Consolidado,
    Estructura,
    Proceso,
    Resultado,
    IndicadoresEstructuraPagination
  },

  data() {
    return {
      title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Indicadores de Estructura, Proceso y Resultado",
          active: true,
        },
      ],

      loading: true,
      selected: null,
      search: "",
      itemData: null,

      lista: [],
      array: [],
      estructureList: [],
      estructura: {
        structure_indicators_list_id: 2,
        data: [], // Array para almacenar la información de cada fila
        year: moment(new Date()).format("YYYY"),
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      token: this.$store.state.auth.user.token || null,
      excel: null,
    }
  },

  methods: {

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    goBack() {
      this.$router.go(-1);
    },

    fetch() {
      this.$refs.paginator.query();
    },

    toggleSelection(rowId, checkId) {
      this.estructureList = this.estructureList.map(item => {
        if (item.id === rowId) {
          return {
            ...item,
            checkList: item.checkList.map(checkItem => {
              return checkItem.id === checkId
                ? { ...checkItem, isActive: !checkItem.isActive }
                : { ...checkItem, isActive: false };
            }),
          };
        } else {
          return item;
        }
      });
    },

    getListEstructure() {
      indicadoresAPI.getListE()
        .then((response) => {
          this.estructureList = response.data.map((item) => ({
            ...item, checkList: [
              {
                id: uuidv4(),
                isActive: false,
                type: 'meets'
              },
              {
                id: uuidv4(),
                isActive: false,
                type: 'fails'
              },
              {
                id: uuidv4(),
                isActive: false,
                type: 'not_apply'
              }
            ]
          }));
          this.loading = true;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    saveImplementacion() {
      this.estructura.data = this.estructureList.map((dato) => {
        const meets = dato.checkList.find((check) => check.type === 'meets').isActive;
        const fails = dato.checkList.find((check) => check.type === 'fails').isActive;
        const no_apply = dato.checkList.find((check) => check.type === 'not_apply').isActive;
        const observations = dato.observations ? dato.observations.trim() : '';

        return {
          id: dato.id,
          meets,
          fails,
          no_apply,
          observations,
        };
      });

      // Validar que al menos un checkbox esté seleccionado y que las observaciones no estén en blanco
      const isValid = this.estructura.data.every(
        (item) => (item.meets || item.fails || item.no_apply) && item.observations !== ''
      );

      if (isValid) {
        // Ahora 'estructura.data' contiene la información de cada fila, puedes enviarla al servidor o realizar la lógica de guardado necesaria.
        evaluacionIndicadoresAPI.saveE(this.estructura)
          .then((response) => {
            if (response.message === "error, ya existe el año") {
              setTimeout(() => {
                Swal.fire({
                  title: "¡error, ya existe un registro de este año!",
                  icon: 'error',
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
              }, 1000);
            } else {
              this.sendNotification(53, 53, true);
              setTimeout(() => {
                Swal.fire({
                  title: "¡Se ha registrado con éxito!",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      } else {
        // Mostrar mensaje de error o realizar alguna acción en caso de que no cumpla con las validaciones
        Swal.fire({
          title: "Error: Debes seleccionar al menos un checkbox y completar las observaciones para cada fila.",
          icon: 'error',
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },

    getList() {
      evaluacionIndicadoresAPI
        .getE(this.$store.getters["company/getCompany"].id)
        .then((response) => {
          this.lista = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    deleteE(id) {
      evaluacionIndicadoresAPI
        .deleteE(id)
        .then((response) => {
          setTimeout(() => {
            Swal.fire({
              title: "Informacion eliminada con éxito!",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },

  mounted() {
    this.getListEstructure();
    this.getList();
  }

}

</script>

<template>

  <div class="row">
    <div class="col-md-12">

      <form class="form-group">
        <table class="pt-2 table table-bordered table-hover border-bottom divide-y divide-gray-200 rounded">
          <thead>
            <tr>
              <th class="text-center" colspan="7"> INDICADORES DE ESTRUCTURA </th>
            </tr>
            <tr>
              <th></th>
              <th>Items</th>
              <th class="text-center align-middle">Cumple</th>
              <th class="text-center align-middle">No cumple</th>
              <th class="text-center align-middle">No aplica</th>
              <th class="text-center align-middle">Observaciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="(dato, index) in estructureList" :key="dato.id">
              <td class="text-center align-middle">{{ dato.id }}</td>
              <td class="align-middle">{{ dato.name }}</td>

              <td v-for="(check, index2) in dato.checkList" class="text-center align-middle">
                <input :id="`${dato.id}${check.type}`" type="checkbox" style="color: #666" :checked="check.isActive"
                  @change="toggleSelection(dato.id, check.id)" />
              </td>

              <td :id="dato.id" class="text-center align-middle col-5">
                <b-form-textarea :id="`${dato.id}`" v-model="dato.observations" maxlength="100"
                  rows="2"></b-form-textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-md-12 col-sm-12 text-right mb-3 d-flex justify-content-end align-items-center">
          <button @click="saveImplementacion" type="button" class="btn btn-primary mr-2">Guardar</button>
        </div>
      </form>

      <div class="row">
        <div class="col-lg-12">
          <div class="card-body">
            <div class="row pb-3">
              <div class="col-6">
                <form @submit.prevent="fetch()" class="form-inline">
                  <div class="form-group mr-2">
                    <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                      class="form-control px-2" placeholder="Buscar"></b-form-input>
                    <div class="col-1">
                      <button type="submit" class="btn btn-primary px-2">Buscar</button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-6"></div>
            </div>
            <div class="table-responsive">
              <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                <thead>
                  <tr>
                    <th class="text-center align-middle">Año</th>
                    <th class="text-center align-middle">Acciones</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="(dato, index) in lista" :key="index">
                    <td class="text-center align-middle">
                      {{ index }}
                    </td>
                    <td class="text-center align-middle">
                      <b-dropdown variant="primary">
                        <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                        <b-dropdown-item
                          :to="{ path: `/forms/estandares/evaluacion-indicadores-estructura-ver/${index}` }">Ver</b-dropdown-item>
                        <b-dropdown-item v-on:click="deleteE(index)">Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
              <IndicadoresEstructuraPagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
